import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
import { ErrorIcon, ValidIcon } from './icons';
import { InputDescription } from './input-description';
const IconWrapper = styled.div `
  margin-right: ${pxToRems(4)};

  svg {
    display: block;
  }

  color: ${({ status, theme }) => status === 'error'
    ? theme.ColorStatusAttention500
    : theme.ColorStatusConstructive400};
`;
const Container = styled.div `
  display: flex;
  align-items: center;
`;
/**
 * This component provides a validation message, either `valid` or `error`
 */
export const InputValidationMessage = ({ status, children, }) => (_jsxs(Container, { children: [_jsxs(IconWrapper, { status: status, children: [status === 'error' && _jsx(ErrorIcon, {}), status === 'valid' && _jsx(ValidIcon, {})] }), _jsx(InputDescription, { status: status, children: children })] }));
//# sourceMappingURL=input-validation-message.js.map